import { DdpCta } from "@/components/shared/DdpCta";
import { DdpImage } from "@/components/shared/DdpImage";
import { TDdpCta, TDdpMedia } from "@/shared/types";

export function ThirdSection(props: Array<{
    cTA: Array<TDdpCta>
    title: string
    description: string
    imageOnTheRight: Array<TDdpMedia>
}>) {
    const { cTA, title, description, imageOnTheRight } = props[0];
    return (
        <div className="landing-third-section">
            <div className="top-media-wrapper">
                <DdpImage image={imageOnTheRight[0]} />
            </div>
            <div className="content-container">
                <div className="content-wrapper">
                    <h2 className="title">{title}</h2>
                    <div className="description" dangerouslySetInnerHTML={{ __html: description }}></div>
                    <DdpCta className="cta-take-quiz " cta={cTA[0]} />
                </div>
            </div>
        </div>
    );
}